//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminBalancePortfolioController_findDiscrepancies,
  Response$AdminBalancePortfolioController_findDiscrepancies$Status$200,
  ResponseContentType$AdminBalancePortfolioController_findDiscrepancies,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminBalancePortfolioController_findDiscrepancies = (options: {
  params: Params$AdminBalancePortfolioController_findDiscrepancies['parameter'];
  config?: QueryOptions<
    Response$AdminBalancePortfolioController_findDiscrepancies$Status$200[ResponseContentType$AdminBalancePortfolioController_findDiscrepancies]
  >;
}) =>
  useApiClient<
    Params$AdminBalancePortfolioController_findDiscrepancies,
    Response$AdminBalancePortfolioController_findDiscrepancies$Status$200[ResponseContentType$AdminBalancePortfolioController_findDiscrepancies]
  >({
    method: 'AdminBalancePortfolioController_findDiscrepancies',
    params: { parameter: options.params },
    config: options.config,
  });
